import React from 'react';
import PropTypes from 'prop-types';
import FilterableDocumentList from '../../components/FilterableDocumentList';
import PageTitle from '../../components/PageTitle';

class DocumentsPage extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
  };

  render() {
    return (
      <div>
        <header>
          <PageTitle>{this.props.title}</PageTitle>
        </header>
        <FilterableDocumentList />
      </div>
    );
  }
}

export default DocumentsPage;
